import React from 'react'
import { Box, Typography } from "@mui/material"
import { analyzerFilters, openEvolutionModal } from "Pages/AnalyzersV2/@signals"
import { IconSeeker, TooltipSeeker } from "@ui-seeker/core"
import { dateFormatReceiver } from "@utils"
import { formatDate, stringToDate } from '@ui-seeker/utils'
import { dsColorNew } from "@palette"
import { alpha } from "@mui/material/styles"

export default function AnalyzerHeaderTable({ label, columnKey, rowKey, rowValues, evolutionColumnValues }) {

	const handleOpenEvolutionModal = () => {
		openEvolutionModal.value = {
			filters: analyzerFilters.value,
			price_data: {
				[columnKey]: evolutionColumnValues[label][0][columnKey],
				[rowKey]: rowValues,
			},
			tableRows: evolutionColumnValues[label]
		}
	}
	const formattedLabel = format => dateFormatReceiver(label) ? formatDate(label, {
		receivedFormat: dateFormatReceiver(label),
		isString: true,
		format: format
	}) : label

	return (
		<TooltipSeeker title="Show Evolution Chart">
			<Box
				data-tour-id="tour-column-header"
				sx={{
					my: 0.5,
					cursor: "pointer",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					transition: "background-color 0.3s ease",
					"&:hover .inner-box": {
						backgroundColor: alpha(dsColorNew.white, 0.12),
					}
				}}
				onClick={handleOpenEvolutionModal}
			>
				<Box
					className="inner-box"
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						gap: 0.3,
						py: 0.5,
						px: 1,
						borderRadius: "6px",
						transition: "transform 0.3s ease",
						flexDirection: 'column',
					}}
				>
					{dateFormatReceiver(label) && <Typography sx={{ fontSize: 12, fontWeight: 600, lineHeight: 1.3 }}>
						{formattedLabel('eeee')}
					</Typography>}
					<Typography sx={dateFormatReceiver(label)
						? { fontSize: 11, fontWeight: 400, lineHeight: 1.3, opacity: 0.8, textTransform: 'none', letterSpacing: 0 }
						: { fontSize: 12, fontWeight: 600, lineHeight: 1.3 }}>
						{formattedLabel('dd MMM yyyy')}
					</Typography>
				</Box>
			</Box>
		</TooltipSeeker>
	)
}
